var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"75.468","height":"96.886","viewBox":"0 0 75.468 96.886"}},[_c('path',{attrs:{"id":"Path_246","data-name":"Path 246","d":"M4673.166,5601v95.886H4747l-41.951-45.931,37.7-49.956Z","transform":"translate(-4672.666 -5600.5)","fill":"#f9850c","stroke":"#872709","stroke-width":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }